import { axiosPrivate } from '../axiosClient';

const useAxiosPrivate = () => {
  return axiosPrivate;
};

export default useAxiosPrivate;
